// extracted by mini-css-extract-plugin
module.exports = {"loading":"WemapLoading_loading__ej76S"};